<template>
  <div id="draw_option" class="drawBarTool">
        <div v-if="isShowPlaceMarkInputDialog">
            <place-mark-input @closeDialog="closeInput" v-bind:placeMarkData="transmissionData"  v-bind:showposition="isshowposition" @savePlaceMark="createPlaceMark"></place-mark-input>
        </div>
        <div v-if="isShowDataSaveDialog">
            <data-save @closeDataSave="closeDataSave" v-bind:userData="userData"></data-save>
        </div>

        <!--add draw tool bar-->
        <div class="drawtoolbar">
            <div class="draw_button" id="arrow"></div>
            <div class="draw_tool" v-bind:class="{active:is_clicked_draw}" id="entity" v-on:click="draw_function" title="Draw">
                <div class="draw_function" v-show="is_show_draw">
                    <div class="draw_button" id="marker" v-on:click="prevent_click"></div>
                    <div class="draw_button" id="normal_line" v-on:click="prevent_click"></div>
                    <div class="draw_button" id="normal_polygon" v-on:click="prevent_click" ></div>
                    <div class="entity" v-bind:class="{active:is_create_entity}" v-on:click="create_entity" title="Add Properties"></div>
                </div>
            </div>

            <!--<div class="draw_tool"  v-bind:class="{active:is_clicked_measure}" id="measure" v-on:click="measure_function" title="Measure">
                <div class="measure_function" v-show="is_show_measure">
                        <div class="draw_button" id="distance" v-on:click="prevent_click"></div>
                        <div class="draw_button" id="area" v-on:click="prevent_click"></div>
                </div>
            </div>-->

            <div class="draw_button" id="distance"></div>
            <div class="draw_button" id="setting"></div>
            <div class="draw_button" id="save"></div>
            <div class="draw_button" id="remove"></div>
            
            
        </div>

        <div class="modal fade" id="draw_dlg">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h5 class="modal-title" id="myModalLabel">Draw Settings</h5>
                    </div>
                    <div class="modal-body">
                        
                        <div id="line_c">
                        <h4><span class="label label-default">Color:</span></h4>
                        <input type="text" value="#00AABB" class="boder-color form-control" />
                        </div>

                        <div>
                        <h4><span class="label label-default">Width:</span></h4>
                        </div>
                        <!--<div id="slider"></div>-->
                        <div>
                            <input id="ex6" type="text" data-slider-min="1" data-slider-max="20" data-slider-step="1" data-slider-value="2">
                            <span id="ex6CurrentSliderValLabel">Current Slider Value: <span id="ex6SliderVal">2</span></span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!--<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>-->
                        <button type="button" class="btn btn-primary">OK</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import PlaceMarkInput from '@/components/PlaceMarkInput'
  import DataSave from '@/components/DataSave'
  export default {
    name: 'DrawToolBar',
    props: {
        userData: {
            default: '' 
        }
    },
    data () {
      return {
        msg: 'This is Draw Tool Bar!',
        isShowDataSaveDialog: false,
        isShowPlaceMarkInputDialog: false,
        isshowposition:true,
        transmissionData: {},
        drawFlag: 0,
        drawDataName: "draw_",
        coordinate: {
          lon: "-1.8402538",
          lat: "-0.4820130",
          h: "-4269.87"
        },
        is_create_entity:false,
        is_show_measure:false,
        is_show_draw:false,
        is_clicked_draw:false,
        is_clicked_measure:false,
        geometry_type:'',
      }
    },
    mounted: function() {
        //add listener
        this.createDrawTool("draw_option");
        $('.boder-color').colorpicker({
            format: 'rgb'
        });

        $('.boder-color').colorpicker().on("changeColor", function (ev) {
            var middle = ev.color.toRGB();
            var linecolor = [];
            linecolor[0] = middle.r/255;
            linecolor[1] = middle.g/255;
            linecolor[2] = middle.b/255;
            pfAirViewer._drawtool.color = linecolor;
        });

        $("#ex6").slider();
        $("#ex6").on("slide", function(slideEvt) {
            $("#ex6SliderVal").text(slideEvt.value);
            pfAirViewer._drawtool.linewidth = slideEvt.value;
        });
        $("#draw_dlg .btn").click(function(){
            $('#draw_dlg').modal('hide');
        });
        
    },
    methods: {

        prevent_click:function(event){
            event.cancelBubble = true;
        },
        draw_function:function(){

            if(this.is_clicked_measure){
                this.is_clicked_measure=false;
                this.is_show_measure=false;
            }

            this.is_show_draw=!this.is_show_draw;
            this.is_clicked_draw=!this.is_clicked_draw;
        },

        measure_function:function(){

            if(this.is_clicked_draw){
                this.is_clicked_draw=false;
                this.is_show_draw=false;
            }

            this.is_show_measure=!this.is_show_measure;
            this.is_clicked_measure = !this.is_clicked_measure;

        },

        create_entity:function(){
           event.cancelBubble = true;
           this.is_create_entity=!this.is_create_entity;
           
           if(this.is_create_entity){
               //$('#entity').css('display','none');
               //$('#measure').css('display','none');
               pfAirViewer._drawtool.convert2entity = true;
           }else{
               //$('#entity').css('display','block');
               //$('#measure').css('display','block');
               pfAirViewer._drawtool.convert2entity = false;
           }

        },
        createDrawTool: function(doomId) {
            var div_array = $("div").children(".draw_button");
            var toolBar = pfAirViewer.createDrawTool(doomId,div_array);
            toolBar.addListener('markerCreated', this.placeMarkCreated);
            toolBar.addListener('measure_distance', pfAirViewer._callBack.on_Measure.bind(pfAirViewer._callBack));
            //toolBar.addListener('measure_area', pfAirViewer._callBack.on_MeasureArea.bind(pfAirViewer._callBack));
            //toolBar.addListener('polylineCreated', pfAirViewer._callBack.on_Draw_Line.bind());
            toolBar.addListener('polylineCreated', this.createPolyline);
            toolBar.addListener('polygonCreated', this.createPolygon);
            toolBar.addListener('settingDraw', this.drawSetting);
            toolBar.addListener('saveData', this.saveData);
            toolBar.addListener('remove', this.removeData);
            toolBar.addListener('convert_entity_from_primitive',this.convert_entity_from_primitive);

        },
        createPolyline: function(event){
            pfAirViewer._callBack.on_Draw_Line(event);
            var layerName = this.drawDataName+this.drawFlag;
                this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'primitive';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._drawDataList.get(pfAirViewer._drawDataList.length-1);
            pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");
            eventBus.$emit('addModelPanel',{
                name: layerName,
                type: "Draw_P_Data"
            });
        },
        createPolygon: function(event){
            pfAirViewer._callBack.on_Draw_Polygon(event);
            var layerName = this.drawDataName+this.drawFlag;
                this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'primitive';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._drawDataList.get(pfAirViewer._drawDataList.length-1);
            pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");
            eventBus.$emit('addModelPanel',{
                name: layerName,
                type: "Draw_P_Data",
                polygonArea: undefined
            });
        },
        convert_entity_from_primitive:function(event){
            //debugger;
            pfAirViewer._callBack.change_primitive(event);
            this.geometry_type = event.type;
            this.isShowPlaceMarkInputDialog = true;
            this.isshowposition = false;
     
        },
        placeMarkCreated: function(event) {
            pfAirViewer._callBack.on_Draw_Placemark(event);
            this.isShowPlaceMarkInputDialog = true;
            this.isshowposition = true;
            this.transmissionData.position = event.position;
            this.geometry_type = undefined;
        },
        createPlaceMark: function(placeMark) {
            //wfc start
            var pmDecJson = {};
            pmDecJson.name = placeMark.name;
            pmDecJson.type = placeMark.type;
            pmDecJson.text = placeMark.description;
            pmDecJson.vedios = placeMark.vedios;
            
            //pfAirViewer._tempPlacemarksEntity.description = pmDecJson;
            //end
            if(this.geometry_type == 'line'){
                pfAirViewer._current_entity.description = pmDecJson;
            }else if(this.geometry_type == 'polygon'){
                pfAirViewer._current_entity.description = pmDecJson;
                if(pfAirViewer._current_entity.polygon.material.color instanceof Cesium.ConstantProperty){
                    var color = pfAirViewer._current_entity.polygon.material.color.getValue();
                    color.alpha = 0.6;
                    pfAirViewer._current_entity.polygon.material.color.setValue(color)
                }
            }else{// create a single placemark
                pfAirViewer._current_entity.description = pmDecJson;
                pfAirViewer._current_entity.position = placeMark.coordinate;
            }
            Cesium.Resource.fetchImage(pfAirViewer._dataSave._placeMarkImage[pmDecJson.type]).then(function(image) {
                pfAirViewer._current_entity.billboard.image.setValue(image);
            }).otherwise(function(error) {
                //an error occurred
            });

            var layerName = this.drawDataName+this.drawFlag;
                this.drawFlag++;

            var drawLayerObject = {};
            drawLayerObject.name = layerName;
            drawLayerObject.type = 'entity';
            drawLayerObject.createdTime = "";
            drawLayerObject.updatedTime = "";
            drawLayerObject.address = "";
            drawLayerObject.cesiumData = pfAirViewer._current_entity;
            pfAirViewer._drawLayerManager.addLayerData(layerName,drawLayerObject);
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"load");
            pfAirViewer._drawLayerManager.setLayerDataStatus(layerName,"show");
            eventBus.$emit('addModelPanel',{
                name: layerName,
                type: "Draw_E_Data"
            });
            
            this.isShowPlaceMarkInputDialog = false;
        },
        closeInput: function(){
            //close placemark input attribute dialog
            //remove entity & restore primitive
            if(pfAirViewer._current_entity.polygon){

                var polygon = new Cesium.AirDrawPolygon({
                    positions: pfAirViewer._current_entity.polygon.hierarchy.valueOf().positions,
                    //width: pfAirViewer._drawtool.linewidth,
                    geodesic: false
                });
                //pfAirViewer.scene.primitives.add(polygon);
                pfAirViewer.drawList.add(polygon);
                polygon.setEditable();
                

            }else if(pfAirViewer._current_entity.polyline){

                var line = new Cesium.AirDrawPolyline({
                    positions: pfAirViewer._current_entity.polyline.positions.valueOf(),
                    width: pfAirViewer._drawtool.linewidth,
                    geodesic: false
                });
                //pfAirViewer.scene.primitives.add(line);
                pfAirViewer.drawList.add(line);
                line.setEditable();
            }else{
                //pfAirViewer.drawList.pop();
                //other
            }
            
            this.isShowPlaceMarkInputDialog = false;
            pfAirViewer.entities.remove(pfAirViewer._current_entity);
            //pfAirViewer._drawPlacemarks.pop();
        },
        closeDataSave :function(){
            this.isShowDataSaveDialog = false;
        },
        drawSetting: function(){
            $('#draw_dlg').modal();
            $('#draw_dlg').appendTo('body');
        },
        saveData: function(){
            if(this.userData.userInfo.isGuest === "no"){
                this.isShowDataSaveDialog = true;
            }
        },
        removeData: function(){
            pfAirViewer._callBack.on_Draw_remove();
            //eventBus.$emit('removePanel');
            //debugger;
        }
    },
    components: {
        PlaceMarkInput,
        DataSave
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.drawBarTool {
    /*background: rgba(1, 1, 1, 0.7) none repeat scroll 0 0;
    right: 100px;
    position: fixed;
    top: 130px;*/
    border-radius: 3px 3px 3px 3px;
    position: relative;
    top: -40px;
    right: 50px;
}


.drawtoolbar {
    background: rgba(48, 51, 54, 0.7) none repeat scroll 0 0;
    border-radius: 3px 3px 3px 3px;
    padding: 0;
    text-align: center;
    width: 40px;
    box-sizing: border-box;
}
.draw_button{
    cursor: pointer;
    display: block;
    height: 20px;
    padding: 20px;
    width: 20px;
    box-sizing: border-box;
}

.draw_tool{
    cursor: pointer;
    display: block;
    height: 20px;
    padding: 20px;
    width: 20px;
    box-sizing: border-box;
}

#measure.active{
   background:#337ab7 url(../../static/images/draw/measure.png) no-repeat scroll center center;
}

#entity.active{
    background: #337ab7 url(../../static/images/draw/draw.png) no-repeat scroll center center;
}

.measure_button{
    cursor: pointer;
    display: block;
    height: 40px;
    padding: 15px;
    width: 40px;
    box-sizing: border-box;
}


.measure_function{
    background: rgba(48, 51, 54, 0.7) none repeat scroll 0 0;
    position: relative;
    top: -18px;
    right: 70px;
    width: 40px;
    height: auto;
    border-radius: 3px 3px 3px 3px;

}

.draw_function{
    background: rgba(48, 51, 54, 0.7) none repeat scroll 0 0;
    position: relative;
    top: -18px;
    right: 70px;
    width: 40px;
    height: auto;
    border-radius: 3px 3px 3px 3px;
}

.measure_distance{
    display: inline;
}

div.line {
    cursor: pointer;
    display: block;
    height: 20px;
    padding: 20px;
    width: 20px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/line.png) no-repeat scroll center center;
}

div.line.active{
    background-color: #0d5881;
}

div.entity{
    cursor: pointer;
    display: block;
    height: 20px;
    padding: 20px;
    width: 20px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/addMark.png) no-repeat scroll center center;
}

div.entity.active{
    background-color: #0d5881;
}

div.draw_sub_menu_line{
    background: rgba(48, 51, 54, 0.7) none repeat scroll 0 0;
    position: relative;
    top: -20px;
    right: 70px;
    width: 40px;
    border-radius: 3px 3px 3px 3px;
}


div.draw_sub_menu_polygon{
    background: rgba(48, 51, 54, 0.7) none repeat scroll 0 0;
    position: relative;
    top: -20px;
    right: 70px;
    width: 40px;
    border-radius: 3px 3px 3px 3px;
}


#make_entity{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/mark.png) no-repeat scroll center center;
}
#normal_line{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/line.png) no-repeat scroll center center;
}
#normal_line:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/line_s.png) no-repeat scroll center center;
}
#entity{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/draw.png) no-repeat scroll center center;
}
#placemark_line{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/polygon.png) no-repeat scroll center center;
}
#placemark_line:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/setting_s.png) no-repeat scroll center center;
}
#normal_polygon{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/polygon.png) no-repeat scroll center center;
}
#normal_polygon:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/polygon_s.png) no-repeat scroll center center;
}
#placemark_polygon{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/mark.png) no-repeat scroll center center;
}
#placemark_polygon:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/setting_s.png) no-repeat scroll center center;
}
#marker {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/mark.png) no-repeat scroll center center;
}
#marker:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/mark_s.png) no-repeat scroll center center;
}
#polygon {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/polygon.png) no-repeat scroll center center;
}
#polygon:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/polygon_s.png) no-repeat scroll center center;
}
#setting {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/setting.png) no-repeat scroll center center;
}
#setting:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/setting_s.png) no-repeat scroll center center;
}
#save {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/save.png) no-repeat scroll center center;
}
#save:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/save_s.png) no-repeat scroll center center;
}
#remove {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/delete.png) no-repeat scroll center center;
}
#remove:hover {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/delete_s.png) no-repeat scroll center center;
}
#measure {
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/measure.png) no-repeat scroll center center;
}

#area{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/measure.png) no-repeat scroll center center;
}

#distance{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/measure.png) no-repeat scroll center center;
}

#distance:hover{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/measure_s.png) no-repeat scroll center center;
}

#arrow{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/arrow_s.png) no-repeat scroll center center;
}

#arrow:hover{
    background: rgba(0, 0, 0, 0) url(../../static/images/draw/arrow.png) no-repeat scroll center center;
}

</style>


// WEBPACK FOOTER //
// src/components/DrawToolBar.vue